import { request } from "@/lib/api";
import { buildDeveloperAccessMutationBody } from "@/lib/developer-access";

export function listDeveloperApiKeys() {
  return request("/api/me/customer-api-keys", { forceFresh: true });
}

export function createDeveloperApiKey(draft) {
  return request("/api/me/customer-api-keys", {
    method: "POST",
    body: JSON.stringify(buildDeveloperAccessMutationBody(draft)),
  });
}

export function updateDeveloperApiKey(keyId, draft) {
  return request(`/api/me/customer-api-keys/${encodeURIComponent(keyId)}`, {
    method: "PATCH",
    body: JSON.stringify(buildDeveloperAccessMutationBody(draft)),
  });
}

export function revokeDeveloperApiKey(keyId) {
  return request(`/api/me/customer-api-keys/${encodeURIComponent(keyId)}`, {
    method: "DELETE",
  });
}

export function listDeveloperApiKeyAudit(keyId, options = {}) {
  const limit = Math.max(1, Math.min(Number(options.limit || 20), 100));
  return request(
    `/api/me/customer-api-keys/${encodeURIComponent(keyId)}/audit?limit=${encodeURIComponent(limit)}`,
    { forceFresh: true },
  );
}
